import React, { useMemo } from 'react';
import styles from './PixInfoBox.module.scss';

/* Assets */
import pixPaymentInfo from '../../../../assets/images/pix-payment-info.png';

/* Interfaces */
import {
  PurchaseStatus,
  usePurchaseStatusProvider,
} from '../../../../../Shops/shared/__providers__/PurchaseStatusProvider';
import { usePaymentProvider } from '../../../../__providers__/PaymentProvider';

interface PixInfoBoxProps {}

export const PixInfoBox: React.FC<PixInfoBoxProps> = () => {
  const { purchaseStatus } = usePurchaseStatusProvider();
  const { linkAuthorize } = usePaymentProvider();

  const paymentInfoMessage: string = useMemo(() => {
    switch (purchaseStatus) {
      case PurchaseStatus.NOT_STARTED:
      default:
        return 'Para pagar, digite seu CPF e clique no botão "Pagar" abaixo.';
      case PurchaseStatus.PENDING:
        return 'Continue com seu pagamento na nova guia aberta.';
      case PurchaseStatus.COMPLETED:
        return 'Pagamento realizado, acesse o aplicativo';
    }
  }, [purchaseStatus]);

  return (
    <div className={styles.container}>
      <img
        alt="PIX payment info"
        src={pixPaymentInfo}
        className={styles.paymentInfoImg}
      />

      <span className={styles.paymentInfoMsg}>
        {paymentInfoMessage}{' '}
        {purchaseStatus === PurchaseStatus.PENDING && (
          <span className={styles.paymentInfoMsg}>
            Se ela não abrir automaticamente,{' '}
            <a
              href={linkAuthorize || '/#'}
              className={styles.paymentInfoMsgAnchor}
              target="_blank"
              rel="noreferrer"
            >
              clique aqui
            </a>
            .
          </span>
        )}
      </span>
    </div>
  );
};
